import React, { ReactElement, useEffect, useRef, useState } from 'react';
import { Tooltip } from 'react-tippy';

import CloseIcon from './CloseIcon/CloseIcon';
import QuestionIcon from './QuestionIcon/QuestionIcon';
import './TextFieldHelper.pcss';

type TextFieldHelperProps = {
  children: ReactElement<any>;
  zIndex?: number;
};

const TextFieldHelper = ({
  children,
  zIndex = 2,
}: TextFieldHelperProps): JSX.Element => {
  const [tooltipVisible, setTooltipVisible] = useState(false);
  const btnRef = useRef(null);

  const clickListener = () => {
    if (!document.activeElement !== btnRef.current) {
      setTooltipVisible(false);
    }
  };

  useEffect(() => {
    if (tooltipVisible) {
      document.addEventListener('click', clickListener);
    } else {
      document.removeEventListener('click', clickListener);
    }
    return () => document.removeEventListener('click', clickListener);
  }, [tooltipVisible]);
  const onClick = () => setTooltipVisible(!tooltipVisible);

  return (
    <Tooltip
      className={'TextFieldHelper'}
      theme="transparent"
      trigger="click"
      html={children}
      position="top"
      open={tooltipVisible}
      duration={0}
      arrow
      popperOptions={{
        modifiers: {
          addZIndex: {
            enabled: true,
            order: 810,
            fn: (data) => ({
              ...data,
              styles: {
                ...data.styles,
                zIndex,
              },
            }),
          },
        },
      }}
    >
      <button
        ref={btnRef}
        className="Tooltip__btn"
        type="button"
        tabIndex={-1}
        onClick={onClick}
      >
        {tooltipVisible ? (
          <CloseIcon className={'Tooltip__icon Tooltip__icon_active'} />
        ) : (
          <QuestionIcon className={'Tooltip__icon '} />
        )}
      </button>
    </Tooltip>
  );
};

export default TextFieldHelper;
